import { useCallback } from "react";
import axios from "axios";

type iFetchData = {
  fetchData: (src: string) => Promise<any>;
};

export const useFetchCMSData = (): iFetchData => {
  const fetchData = useCallback(
    async (src: string): Promise<any> =>
      axios
        .get(src)
        .then((response: any) => response.data)
        .catch((error: any) => console.error(error)),
    [],
  );

  return { fetchData };
};
